import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import RootLayout from './RootLayout'

/**
 * Frame for the 404 catch-all (UI audit S8): a signed-in viewer who follows
 * a dead link keeps the app shell — sidebar, header, tenant brand — and can
 * navigate straight on; a visitor gets the bare page. The page itself is the
 * route's child, rendered through RootLayout's Outlet or this one.
 */
export default function NotFoundLayout() {
  const isAuthenticated = useSelector((state) => Boolean(state.auth?.isAuthenticated))
  return isAuthenticated ? <RootLayout /> : <Outlet />
}
